import { type BoxType } from '@backrs_ui/grow-ui/src/components/PageShell/resourceTabs/InfoBox.config';

import { type CustomTabId } from './customTabIds';

export type TabItem =
  | Readonly<{ kind: 'page-content' }>
  | Readonly<{ kind: 'resource'; boxType: BoxType }>
  | Readonly<{ kind: 'custom'; tabId: CustomTabId }>;

export type TabKey = 'page-content' | `resource:${BoxType}` | `custom:${CustomTabId}`;

export const getTabKey = (tab: TabItem): TabKey => {
  switch (tab.kind) {
    case 'page-content':
      return 'page-content';
    case 'resource':
      return `resource:${tab.boxType}`;
    case 'custom':
      return `custom:${tab.tabId}`;
  }
};
